<template>
    <div class="">
        <b-row class="justify-content-center">
            <h5>{{ labels.title }}</h5>
        </b-row>
        <!-- <pre>{{ infoFinanciera }}</pre> -->
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.activoCorriente}}</h5>
            </b-col>
            <b-col cols="6" class="text-left">
                <input type="number" v-model="infoFinanciera.activo_corriente" class="form-control">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.activoNoCorriente}}</h5>
            </b-col>
            <b-col cols="6" class="text-left">
                <input type="number" v-model="infoFinanciera.activo_no_corriente" class="form-control">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.totalActivo}}</h5>
            </b-col>
            <b-col cols="6" class="text-left">
                <input type="number" v-model="infoFinanciera.total_activo" class="form-control">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.pasivoCorriente}}</h5>
            </b-col>
            <b-col cols="6" class="text-left">
                <input type="number" v-model="infoFinanciera.pasivo_corriente" class="form-control">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.pasivoNoCorriente}}</h5>
            </b-col>
            <b-col cols="6" class="text-left">
                <input type="number" v-model="infoFinanciera.pasivo_no_corriente" class="form-control">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.totalPasivo}}</h5>
            </b-col>
            <b-col cols="6" class="text-left">
                <input type="number" v-model="infoFinanciera.total_pasivo" class="form-control">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.utilidadAcumulada}}</h5>
            </b-col>
            <b-col cols="6" class="text-left">
                <input type="number" v-model="infoFinanciera.utilidad_acumulada" class="form-control">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.totalPatrimonio}}</h5>
            </b-col>
            <b-col cols="6" class="text-left">
                <input type="number" v-model="infoFinanciera.total_patrimonio" class="form-control">
            </b-col>
        </b-row>
        <b-row class="">
            <b-col cols="1"></b-col>
            <b-col cols="5" class="text-left">
                <h5>{{labels.ebit}}</h5>
            </b-col>
            <b-col cols="6" class="text-left">
                <input type="number" v-model="infoFinanciera.ebit" class="form-control">
            </b-col>
        </b-row>
        <md-dialog-actions class="">
            <md-button class="md-primary" @click="guardarInfoFinanciera">{{ labels.save }}</md-button>
            <!-- <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button> -->
        </md-dialog-actions>
    </div>
</template>

<script>
import InformacionFinanciera from '../../../services/InformacionFinanciera';

export default {
    name : 'Modificar',
    props : ['infoFinanciera'],
    data : () => ({
        
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : 'Información financiera',
                    save : 'Guardar',
                    close : 'Cerrar',
                    vigencia : 'Vigencia',
                    activoCorriente : 'Activo corriente',
                    activoNoCorriente : 'Activo no corriente',
                    totalActivo : 'Total activo',
                    pasivoCorriente : 'Pasivo corriente',
                    pasivoNoCorriente : 'Pasivo no corriente',
                    totalPasivo : 'Total pasivo',
                    utilidadAcumulada : 'Utilidad acumulada',
                    totalPatrimonio : 'Total patrimonio',
                    ebit : 'EBIT'
                }
            }else{
                return {
                    title : 'Edit',
                    save : 'Save',
                    close : 'Close',
                    vigencia : 'Validity',
                    activoCorriente : 'Current assets',
                    activoNoCorriente : 'Non-current asset',
                    totalActivo : 'Total assets',
                    pasivoCorriente : 'Passive current',
                    pasivoNoCorriente : 'Passive Non-Current',
                    totalPasivo : 'Total liabilities',
                    utilidadAcumulada : 'Accumulated profit',
                    totalPatrimonio : 'Total Assets',
                    ebit : 'EBIT'
                }
            }
        }
    },
    methods : {
        guardarInfoFinanciera(){
            const dataForm = [
                this.infoFinanciera.vigencia,
                this.infoFinanciera.activo_corriente,
                this.infoFinanciera.activo_no_corriente,
                this.infoFinanciera.total_activo,
                this.infoFinanciera.pasivo_corriente,
                this.infoFinanciera.pasivo_no_corriente,
                this.infoFinanciera.total_pasivo,
                this.infoFinanciera.utilidad_acumulada,
                this.infoFinanciera.total_patrimonio,
                this.infoFinanciera.ebit,
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            
            }else{

                let info = {
                    'id' : this.infoFinanciera.id,
                    'vigencia' : this.infoFinanciera.vigencia,
                    'activoCorriente' :this.infoFinanciera.activo_corriente,
                    'activoNoCorriente' : this.infoFinanciera.activo_no_corriente,
                    'totalActivo' : this.infoFinanciera.total_activo,
                    'pasivoCorriente' : this.infoFinanciera.pasivo_corriente,
                    'pasivoNoCorriente' : this.infoFinanciera.pasivo_no_corriente,
                    'totalPasivo' : this.infoFinanciera.total_pasivo,
                    'utilidadAcumulada' : this.infoFinanciera.utilidad_acumulada,
                    'totalPatrimonio' : this.infoFinanciera.total_patrimonio,
                    'ebit' : this.infoFinanciera.ebit,
                    'idUser' : this.$store.state.userId
                }
                // console.log(info);

                InformacionFinanciera.updateInformacionFinanciera(info)
                .then((res) => {
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location. reload()                    
                    }
                })
                .catch((err) => console.log(err))
            }
        }
    }
}
</script>

<style>

</style>